/**
 * HostMisconfigured.tsx — strona „Nieznany adres" (F12.N D1, 2026-05-15).
 *
 * Renderowana przez `App.tsx` gdy `useHostScope()` zwróci `'unknown'` —
 * user trafił na hostname nie pasujący do żadnego wzorca (`admin.*` /
 * `<slug>.app.*` / `app.*`). Typowy przypadek: tenant URL bez `.app.`
 * w środku (np. `kominek.wfnew-dev.ite.pl` zamiast `kominek.app.wfnew-dev.ite.pl`).
 *
 * Wcześniej taki host fallbackował na `admin` scope i pokazywał panel ITE —
 * super-admin mógł niechcący zalogować się na nieistniejącej subdomenie i
 * operować jak po panelu ITE (zgłoszone przez Eugenię 2026-05-15).
 *
 * Strona jest pure-static — nie używa `api.ts`, więc axios interceptor (który
 * w scope `unknown` jest pass-throughem) nie ma okazji się odpalić.
 */

import { useTranslation } from 'react-i18next';

export function HostMisconfigured() {
  const { t } = useTranslation();
  const currentHost = typeof window !== 'undefined' ? window.location.host : '';

  return (
    <main className="flex min-h-screen items-center justify-center bg-bg-secondary p-4">
      <div className="w-full max-w-lg rounded-2xl border border-border-secondary bg-bg-elevated p-8 shadow-xl">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-warning-50 text-warning-700">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-text-primary">{t('hostMisconfigured.title')}</h1>
        </div>

        <p className="mb-4 text-sm text-text-secondary">
          {t('hostMisconfigured.body')}{' '}
          <code className="rounded bg-bg-tertiary px-1.5 py-0.5 text-text-primary">.app.</code>
        </p>

        <div className="mb-4 rounded-lg border border-border-secondary bg-bg-tertiary p-4 text-sm">
          <div className="mb-2">
            <span className="text-text-tertiary">{t('hostMisconfigured.exampleLabel')}: </span>
            <code className="text-text-primary">firma.app.wfnew-dev.ite.pl</code>
          </div>
          {currentHost && (
            <div>
              <span className="text-text-tertiary">{t('hostMisconfigured.currentLabel')}: </span>
              <code className="text-error-600">{currentHost}</code>
            </div>
          )}
        </div>

        <p className="text-sm text-text-tertiary">{t('hostMisconfigured.hint')}</p>
      </div>
    </main>
  );
}
